/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Audio_Recorder_Event_LabelInputs */



/**
* | output |
* | --- |
* | "Event {index}" |
*
* @param {Audio_Recorder_Event_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_event_label = /** @type {((inputs: Audio_Recorder_Event_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Event_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Événement ${i?.index}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Ereignis ${i?.index}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Evento ${i?.index}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Событие ${i?.index}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Evento ${i?.index}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`事件${i?.index}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`イベント ${i?.index}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`घटना ${i?.index}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Evento ${i?.index}`)
	return /** @type {LocalizedString} */ (`Event ${i?.index}`)
});